module.exports = __webpack_public_path__ + "static/media/t4.54fa7bd8.png";